export { default } from './part-button';
